import "../stylesheets/WelcomeScreen.css";

import React from "react";

import ScreenManager from "../manager/ScreenManager";

import Button from "react-bootstrap/Button";

const screenManager = ScreenManager.instance;

export default class WelcomeScreen extends React.PureComponent {

    render() {

        return (
            <div className="centeredItems flexContainer secondaryColorBackground" id="welcomeScreen-container" >

                <div id="welcomeScreen-logoContainer">
                    <img src={require("../assets/logo.jpeg")} alt="Das Logo von KlimaLeaks" />
                </div>

                <div id="welcomeScreen-textBlockContainer">
                    <h3 className="centeredText" >Bis auf wenige Ausnahmen ist die Notwendigkeit der Umstellung auf regenerative und ressourcenschonende Energieversorgung gesellschaftlicher Konsens.</h3>
                    <br/>
                    <h3 className="centeredText" >Die Ziele sind klar, der Weg dahin jedoch kompliziert und durch Zusammenhänge behindert, die mit den Erfahrungen von Experten aufgeklärt und Verantwortlichkeiten und Lösungswege aufgezeigt werden sollen.</h3>
                </div>

                <Button id="welcomeScreen-buttonReasons" onClick={() => screenManager.pushScreen("PagesOverview", { section: "reasons" })} >Warum die Energiewende scheitert...</Button>
                <Button id="welcomeScreen-buttonPossibilities" onClick={() => screenManager.pushScreen("PagesOverview", { section: "possibilities" })} >...und was wir tun können!</Button>

            </div>
        );

    }

}